export const aiServiceLinks = [
  { label: "AI Opportunity Assessment", to: "/services/ai-opportunity-assessment" },
  { label: "AI Implementation", to: "/services/ai-implementation" },
  { label: "Workflow Automation", to: "/services/workflow-automation" },
  { label: "AI Enablement", to: "/services/ai-enablement" },
] as const;

// The funding service pages, /services, /tools, /blog and /guides/* are draft
// routes (see src/lib/draft-routes.ts) and are deliberately absent from nav.
export const serviceLinks = aiServiceLinks;

export const SCORECARD_PATH = "/tools/ai-opportunity-scorecard";

export const companyLinks = [
  { label: "Results", to: "/results" },
  { label: "Contact", to: "/contact" },
] as const;

export const resourceLinks = [
  { label: "Articles", to: "/blog" },
  { label: "AI Opportunity Scorecard", to: SCORECARD_PATH },
] as const;

export const legalLinks = [
  { label: "Privacy", to: "/legal/privacy" },
  { label: "Terms", to: "/legal/terms" },
  { label: "Disclaimer", to: "/legal/disclaimer" },
  { label: "Accessibility", to: "/legal/accessibility" },
] as const;

export const primaryNavLinks = [{ label: "Results", to: "/results" }] as const;

export const BOOK_CTA_LABEL = "Book a Free AI Call";

export const DISCLAIMER =
  "LAA Concierge Consulting, LLC is an independent business consulting firm. We are not a lender, a bank, or a loan broker, and we are not affiliated with or endorsed by the U.S. Small Business Administration or any government agency. We do not guarantee loan approval, grant awards, or any specific funding outcome. Consulting fees are for advisory and preparation services only.";
